<template>
    <div class="d-inline-block">
        <v-btn color="info" variant="text" size="small" @click="openDialog">
            <v-icon left>mdi-information</v-icon>
            {{ buttonLabel }}
        </v-btn>
        <MasterDataReferenceDialog v-model="showDialog" :title="dialogTitle" :items="items" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import MasterDataReferenceDialog from './MasterDataReferenceDialog.vue';

export default defineComponent({
    name: 'MasterDataReferenceButton',

    components: {
        MasterDataReferenceDialog
    },

    props: {
        buttonLabel: {
            type: String,
            required: true
        },
        dialogTitle: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            default: () => []
        }
    },

    setup() {
        const showDialog = ref(false);

        const openDialog = () => {
            showDialog.value = true;
        };

        return {
            showDialog,
            openDialog
        };
    }
});
</script>

<style scoped></style>
